import { Component, inject, Inject } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MAT_DIALOG_DATA, MatDialogContent, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { ConfirmationDialogComponent } from "../confirmation-dialog/confirmation-dialog.component";
import { Router } from "@angular/router";
import { IndicationQuoteStepService } from "../../../services/indicationQuoteStep.service";

@Component({
    selector: 'app-approved-states-restriction-dialog',
    standalone: true,
    imports: [MatButtonModule,MatDialogModule, MatDialogContent],
    templateUrl: './approved-states-restriction-dialog.component.html',
    styleUrl: './approved-states-restriction-dialog.component.scss'
})
export class ApprovedStatesRestrictionDialog{
    router = inject(Router)
    indicationService = inject(IndicationQuoteStepService)
    constructor(private dialogRef: MatDialogRef<ConfirmationDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: { message: string }) {}

    onResponse() {
        this.dialogRef.close(true); 
    }

    onExitResponse(){
        this.indicationService.removeIndicationQuoteStorageData()
        this.dialogRef.close(true); 
        this.router.navigate(['/quote'])
    }
}